<template>
    <div class="mb-5 pb-4">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Finanzas-publicas'"/>
        </div>
        <div class="container text-center mb-4">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Información Financiera de los Entes Públicos</h1>
        </div>
        <p>El Portal Web de la Secretaría de Hacienda del Estado de Chiapas, sirve de enlace para que Usted consulte la Información Financiera que emiten los Entes Públicos del Estado de Chiapas. El contenido de la información es responsabilidad del Ente Público que la emite.</p>
        <div>
            <div class="col-md-12 col-12 mb-3" v-if="listOpc">
                <px-select idSelect="entes_publicos" placeholder="Seleccione la opción a consultar" :options="listOpc" @KuramaSelect="opcSeleccionada = $event"></px-select>
            </div>
        </div>
        <div v-if="opcSeleccionada && dataContentOpcSel" class="mt-3">
            <!-- <h4>{{opcSeleccionada.text}}</h4> -->
            <div v-if="flagArrays">
                <card-collapse-docs :sections="dataContentOpcSel[0].secciones" :urlServe="urlServe" :filtros="1"/>
            </div>
            <div v-else> <!-- <p>Es modelo 2</p> -->
                <!-- <pre>{{ data }}</pre> -->
                <tabla-simple id="tablaIFEPFiltros" class="mt-5" :titulo="data.text" :datos="data" />
            </div>
        </div>
        <div class="mt-5">
            <span v-html="fecha_actualizacion"></span>
        </div>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import InformeFinanzasPub from "@/services/rendicionDeCuentas/informeFinanzaPub/informeFinanzaPub.js";
const _serviciosInformeFinanzasPub = new InformeFinanzasPub();
import selectOpc from "../../../components/selectEjercicio.vue";
import botonAtras from '../../button-atras.vue';
import cardCollapseDocs from '@/components/cardcollapseSubs.vue';
import tablaSimple from '@/components/tablaSimple.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

import('@/assets/css/tablaTypeFiles.css');
export default {
    mixins: [DateFormat],
    components: { selectOpc, botonAtras, cardCollapseDocs, tablaSimple},
    created(){
        window.scrollTo(0, 0);
        this.getListadoOpciones();
    },
    data(){
        return{
            listOpc: [],
            opcSeleccionada: null,
            dataContentOpcSel: [],
            flagArrays: null,
            data: [],
            fecha_actualizacion:''
        }
    },
    methods:{
        async getListadoOpciones() {
            try {
                const response = await _serviciosInformeFinanzasPub.getOpcionesIFEP(mapFun.opcionesIFEP);
                this.listOpc = response.data; 
                let fecha_texto = response.data[0].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                this.listOpc = this.listOpc[0].contenido.map(function (mapeoSelect) {
                    return {
                        id: mapeoSelect.id,
                        value: mapeoSelect.descripcion,
                        text: mapeoSelect.titulo,
                    };
                });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getContenidoOpcIFEP(){
            try {
                let opc_sel = this.opcSeleccionada.value;
                let ruta = mapFun.contenidoOpcIFEP;

                ///ojooooo se quita cuando se estabilice los jsons
                let ruta_completa = ""; 
                opc_sel != 'IFEP-IC'? ruta_completa = ruta+opc_sel+".json" : ruta_completa = ruta+opc_sel+"-Remasterizado.json";
                //////////////////////////////////////////////////////////////////////////////////////

                // let ruta_completa = ruta+opc_sel+".json";
                const response = await _serviciosInformeFinanzasPub.getInfoIFEPPorOpc(ruta_completa);
                this.dataContentOpcSel = response.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        reordenarArchivos(){
            this.dataContentOpcSel.forEach(element => {
                element.secciones.forEach(seccion =>{
                    if(seccion.titulo_seccion != ''){
                        seccion.contenido_seccion = seccion.contenido_seccion.reverse();
                    }
                    seccion.contenido_seccion.forEach(contenido_secc =>{
                        contenido_secc.contenido.forEach(subcontenido =>{
                            subcontenido.archivos_seccion = subcontenido.archivos_seccion.reverse()
                        })
                    })
                })
            })
        },
    },
    watch:{
        opcSeleccionada(){
            if(this.opcSeleccionada){this.getContenidoOpcIFEP();}
        },
        dataContentOpcSel(){
            if(this.dataContentOpcSel){                                                                                                                                                                                                                                                                                                                  
                if(this.dataContentOpcSel.length > 0){ 
                    let obj_prueba = this.dataContentOpcSel[0];
                    this.flagArrays = obj_prueba.hasOwnProperty("secciones")
                    if(this.flagArrays == false){
                        let fecha_texto = this.dataContentOpcSel[this.dataContentOpcSel.length - 1].fecha_actualizacion;
                        this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                        this.data = {
                            id: 1,
                            text: this.opcSeleccionada.text,
                            seccion: this.dataContentOpcSel
                        }   
                    }
                }
            }
        },
        flagArrays(){
            if(this.flagArrays){this.reordenarArchivos();}
        }
    }
}
</script>